module.exports = __webpack_public_path__ + "static/base-1-0fddf7abf908310e4a40721eec0d229b.jpg";